import { useEffect } from 'react';
import moment from 'moment';
import { useFormContext } from 'react-hook-form';
import { FormValues } from '../../schema';

const useTimeSync = (): void => {
    const { watch, setValue } = useFormContext<FormValues>();
    const [start, end, cancellationDeadline, registrationDeadline] = watch([
        'start_at',
        'end_at',
        'last_cancel_at',
        'last_confirm_at',
    ]);

    useEffect(() => {
        if (start) {
            if (moment(start).isBefore(moment().endOf('minute'))) {
                setValue('start_at', moment().add(1, 'minute').startOf('minute').toDate());
            }
        }
    }, [start, setValue]);

    useEffect(() => {
        if (start && end) {
            if (cancellationDeadline) {
                if (moment(cancellationDeadline).isAfter(end)) {
                    setValue('last_cancel_at', end);
                }
            }

            if (registrationDeadline) {
                if (moment(registrationDeadline).isAfter(end)) {
                    setValue('last_confirm_at', end);
                }
            }
        }
    }, [cancellationDeadline, end, registrationDeadline, setValue, start]);
};

export default useTimeSync;
